import * as React from "react";
import SideBarContainer from "../layouts/sideBar.container";

declare const window: any;

export default function AmenitiesContainer({
  data,
  isPortrait,
  setSpinSelected,
  setGaleriaSelected,
  setOriginalGleriaSelected,
  setSubMenuSelected,
  subMenuSelected,
  setMenuSelected,
  menuSelected,
  theme,
  isSelected,
  setIsSelected,
  isSelectedAttributes,
  setIsSelectedAttributes,
  icono,
  colors,
  setFrame,
  isSideBar,
  setIsSideBar,
  setIsAnimationAmenites,
  amenities_hierarchical
}: any) {
  
  return (
    <div className={`townplanning-container`}>
      <SideBarContainer
        data={data}
        isPortrait={isPortrait}
        setSpinSelected={setSpinSelected}
        setGaleriaSelected={setGaleriaSelected}
        setOriginalGleriaSelected={setOriginalGleriaSelected}
        setSubMenuSelected={setSubMenuSelected}
        subMenuSelected={subMenuSelected}
        setMenuSelected={setMenuSelected}
        theme={theme}
        isSideBar={isSideBar}
        setIsSideBar={setIsSideBar}
        menuSelected={menuSelected}
        icono={icono}
        isSelected={isSelected}
        setIsSelected={setIsSelected}
        isSelectedAmenitiesAttributes={isSelectedAttributes}
        setIsSelectedAmenitiesAttributes={setIsSelectedAttributes}
        colors={colors}
        setFrame={setFrame}
        setIsAnimationAmenites={setIsAnimationAmenites}
        amenities_hierarchical={amenities_hierarchical}
      />
    </div>
  );
}
